import { render } from "./characterEmail.vue?vue&type=template&id=6b838700"
import script from "./characterEmail.vue?vue&type=script&lang=js"
export * from "./characterEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__